import axionIns from "../axios";

const sendLogs = async (payload) => {
  return axionIns
    .post("auth/logs", JSON.stringify(payload))
    .then((response) => {
      return response.data;
    });
};

const exportObject = {
  sendLogs,
};
export default exportObject;
